// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__3tY0D","label":"Completed_label__1tiUh"};